import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import ContainerWithTitle from './../../containers/HOC/ContainerWithTitle'
import {
  TableRow,
  TableCell,
  Button,
  Grid,
  ListItem,
  MenuItem,
  InputAdornment,
  Switch,
  FormHelperText,
  Table,
  Paper,
  LinearProgress,
} from '@material-ui/core'
import {
  getRegions,
  getRegionById,
  updateRegion,
  saveNewRegion,
  getKmlById,
  getTaxRateByCompany,
  overlappingRegion,
} from '../../actions/company'
import {
  EditableTextField,
  EditableSelect,
  EditableInput,
  EditableReactSelect,
  EditableReactSelectCreatable,
} from '../common/EditableComponents'
import { Element } from 'react-scroll'
import { Appcues } from '../../utils/constants'
import KmlUtils from '../../utils/kml-utils'
import { uploadAssetAPI } from '../../api/assets'
import ModalDialog from '../common/ModalDialog'
import validateInputRegion from '../../utils/validations/region'
import { openErrorMessage } from '../../actions/message'
import ModalDeliveryTaxRate from '../../containers/Settings/Shop/Modals/ModalDeliveryTaxRate'
import { getSession } from '../../utils/api'
import { UnleashToggles } from '../../types/unleashToggles'
import { monolithIsFeatureFlagEnable } from '../../api/unleash'
import { getConsumerTypes } from '../../api/consumer-type'

const options = [
  { label: 'Monday', value: 'Monday' },
  { label: 'Tuesday', value: 'Tuesday' },
  { label: 'Wednesday', value: 'Wednesday' },
  { label: 'Thursday', value: 'Thursday' },
  { label: 'Friday', value: 'Friday' },
  { label: 'Saturday', value: 'Saturday' },
  { label: 'Sunday', value: 'Sunday' },
]

const optionZones = [
  { label: 'KML', value: 'kml' },
  { label: 'Zipcode', value: 'zipCode' },
]

const styles = {
  //fontFamily: "sans-serif",
  fontFamily: 'Helvetica Neue',
  textAlign: 'center',
  display: 'flex',
  maxwidth: 100,
  height: 30,
  justifyContent: 'center',
}

const styleNoSelectedMap = {
  fontFamily: 'Helvetica Neue',
  textAlign: 'center',
  display: 'flex',
  maxwidth: 100,
  margin: 150,
  // width:520,
  // height:620,
  justifyContent: 'center',
}

class RegionsEdit extends PureComponent {
  constructor(props) {
    super(props)
    this.handleButtonFile = this.handleButtonFile.bind(this)
    this.onMaP = this.onMaP.bind(this)
    this.state = {
      region: {
        name: '',
        active: true,
        regionDefault: false,
        regionType: '',
        deliveryFee: '',
        openAt: '',
        closeAt: '',
        daysClose: [],
        minOrderAmount: '',
        freeDeliveryAfter: '',
        handleButtonFile: '',
        kmlEdges: [],
        taxRuleId: 'InheritFromShop',
        openAtnumeric: '',
        closeAtnumeric: '',
        zipCodes: [],
        zoneType: 'zipCode',
        kmlColor: '#3e41ea',
      },
      dataToEdit: {},
      files: [],
      flag: true,
      editMode: true,
      regionId: '',
      errors: {},
      parameters: [],
      parameterRegion: [],
      message: '',
      taxRule: [],
      listregion: [],
      nameRegionActive: '',
      coordinatesActive: [],
      coordinatesCenterActive: [],
      hover: false,
      openAtnumericState: '',
      closeAtnumericState: '',
      selectZones: '',
      arrayZipCode: [],
      loading: false,
      showModalDeliveryTaxRate: false,
      regionConsumerTypeFlag: false,
      consumerTypes: [],
      consumerTypeDropdownOptions: [],
    }
  }

  componentDidMount() {
    let loc = this.props.location.pathname.split('/')
    this.getNameTaxRule()
    this.onDefaultRegion()
    this.getlistregions()
    // this.hourRepeatOpenClose();
    if (loc.length > 5) {
      if (loc[loc.length - 1] == 'edit') this.getRegionById(loc[loc.length - 2])
    }
    this.checkRegionConsumerFlag()
    this.fetchConsumerTypes()
  }

  fetchConsumerTypes = async () => {
    const consumerTypes = await getConsumerTypes()
    if (consumerTypes) {
      const consumerTypeDropdownOptions = consumerTypes.map((type) => ({
        value: type.type,
        label: type.displayName,
      }))
      this.setState({ consumerTypes, consumerTypeDropdownOptions })
    }
  }

  getlistregions() {
    this.props.dispatch(getRegions()).then((res) => {
      this.setState({ listregion: res })
    })
  }

  getRegionById = (id) => {
    this.props.dispatch(getRegionById(id)).then((res) => {
      this.setState({ region: res, regionId: res.id, editMode: false })
      this.onCoordinateDefault()
    })
  }

  onChange =
    (key, isCheckBox = false) =>
    (event) => {
      const value = isCheckBox ? event.target.checked : event.target.value
      this.setState((prevState) => ({
        region: {
          ...prevState.region,
          [key]: value,
        },
        errors: {},
      }))
      if (key == 'kmlColor') {
        if (
          this.state.region &&
          this.state.region.kmlEdges &&
          this.state.region.kmlEdges.length > 0
        ) {
          const activeKml = this.state.region.kmlEdges.find((kml) => kml.active)
          if (activeKml) {
            this.onMaP(activeKml.coordinates, activeKml.coordinates[3], event.target.value)
          }
        }
      }
    }

  onSave = () => {
    const { region } = this.state
    if (this.isValid(region)) {
      if (region.zoneType === 'zipCode') {
        let { hasRepeatedCode, repetedZipCodes } = this.onVerifyZipCodeRegions(
          region.zipCodes,
          region,
        )
        if (hasRepeatedCode) {
          this.props.dispatch(
            openErrorMessage(
              `ZipCode ${repetedZipCodes} can't be used because it belongs to another region`,
            ),
          )
          return
        }
      }

      this.props.dispatch(saveNewRegion(region)).then((res) => {
        Appcues.track('Region saved')
        this.props.history.push('/settings/company/regions')
      })
    }
  }

  onUpdateRegion = () => {
    const { region } = this.state
    if (this.isValid(region)) {
      if (region.zoneType === 'zipCode') {
        let { hasRepeatedCode, repetedZipCodes } = this.onVerifyZipCodeRegions(
          region.zipCodes,
          region,
        )
        if (hasRepeatedCode) {
          this.props.dispatch(
            openErrorMessage(
              `ZipCode ${repetedZipCodes} can't be used because it belongs to another region`,
            ),
          )
          return
        }
      }

      this.props.dispatch(updateRegion(region)).then((res) => {
        Appcues.track('Region update')
        this.props.history.push('/settings/company/regions')
      })
    }
  }

  isValid = (region) => {
    const { errors, isValid } = validateInputRegion(region)

    if (!isValid) this.setState({ errors })

    return isValid
  }

  backregions = () => {
    this.props.history.push('/settings/company/regions')
  }

  handleButtonFile(e) {
    var file = e.target.files[0]
    const kmlUtils = new KmlUtils()
    let fileReader = new FileReader()
    if (file) {
      fileReader.onload = async (e) => {
        let result = await kmlUtils.extractGoogleCoords(e.target.result)
        if (result && result.polygons && result.polygons.length > 1) {
          console.log('More than 1 polygon')
          //return
        } else {
          this.props.dispatch(overlappingRegion(result.polygons[0])).then((response) => {
            if (response && response.name) {
              this.modalOverlappingRegion.handleClickOpen()
              this.setState({ regionName: response.name })
            }
          })

          uploadAssetAPI(file, 'kml')
            .then((response) => {
              let kmlEdge = {
                active: false,
                coordinates: result && result.polygons && result.polygons[0],
                asset: response,
              }

              if (this.state.region.kmlEdges.length === 0) {
                kmlEdge.active = true
                this.setState((prevState) => ({
                  region: {
                    ...prevState.region,
                    kmlEdges: [...(this.state.region.kmlEdges || []), kmlEdge],
                  },
                }))
                this.setState({ loading: false })
                if (kmlEdge.coordinates) {
                  this.onMaP(kmlEdge.coordinates, kmlEdge.coordinates[3], '')
                  this.setState({ loading: false })
                }
              } else {
                // validation
                // validate coordinates
                const currentCoordinatesAsString =
                  (this.state.region.kmlEdges &&
                    this.state.region.kmlEdges.length > 0 &&
                    this.state.region.kmlEdges.map((kml) => {
                      return JSON.stringify(kml.coordinates)
                    })) ||
                  []
                const newCoordinatesAsString = JSON.stringify(kmlEdge.coordinates)
                const isCoordinatesRepeated =
                  currentCoordinatesAsString.indexOf(newCoordinatesAsString) > -1 ? true : false

                // validate name
                const isNameRepetead =
                  this.state.region.kmlEdges &&
                  this.state.region.kmlEdges.find((kml) => kml.asset.name == file.name)

                // validate if another kml is active
                const activeKml =
                  this.state.region.kmlEdges && this.state.region.kmlEdges.find((kml) => kml.active)
                kmlEdge.active = !activeKml ? true : false

                if (isNameRepetead || isCoordinatesRepeated) {
                  if (isNameRepetead) {
                    this.modalDuplicateKml.handleClickOpen()
                    this.setState({ loading: false })
                  }
                  if (isCoordinatesRepeated) {
                    this.modalDuplicatecoordinates.handleClickOpen()
                    this.setState({ loading: false })
                  }
                } else {
                  this.setState((prevState) => ({
                    region: {
                      ...prevState.region,
                      kmlEdges: [...(this.state.region.kmlEdges || []), kmlEdge],
                    },
                  }))
                  this.setState({ loading: false })
                }
              }
            })
            .catch(function (error) {
              console.log(error)
              this.setState({ loading: false })
              this.onError((error.response && error.response.data.message) || '')
            })
        }
      }

      fileReader.readAsText(file)
    }
  }

  onError = (message) => this.props.dispatch(openErrorMessage(message))

  convertHour = (hour) => {
    const hourAsArray = (hour == null ? '' : hour).split(':')
    const hours = parseInt(hourAsArray[0])
    const minutes = parseInt(hourAsArray[1], 10)

    return hours * 60 + minutes
  }

  getAssetKml = (key, name) => {
    this.props
      .dispatch(getKmlById(key))
      .then((response) => {
        Appcues.track('Download kml')
        let blob = new Blob([response], {
          type: 'application/vnd.google-earth.kml+xml',
        })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      })
      .catch(function (error) {
        console.log(error)
      })
    // }
  }

  onDeleteKML = (index, keyDelete) => {
    const kml =
      this.state.region && this.state.region.kmlEdges.find((Kml) => Kml.asset.key != keyDelete)
    if (kml) {
      this.setState((prevState) => ({
        region: {
          ...prevState.region,
          kmlEdges: [kml],
        },
      }))
      this.onMaP([], [], '')
    } else {
      this.setState((prevState) => ({
        region: {
          ...prevState.region,
          kmlEdges: [],
        },
      }))

      this.onMaP([], [], '')
    }
  }

  onConfirm = () => {
    this.buildChangeCheckbox(this.state.parameters[0], this.state.parameters[1])
    this.confirmModal.handleClose()
  }
  onClose = () => {}

  handleChange = (activeStatus, itemId) => {
    this.state.parameters = [activeStatus, itemId]
    let kmlEdges = [...this.state.region.kmlEdges]
    const arrayRepeatedTrue = []
    for (const item of kmlEdges) {
      if (item.active) {
        arrayRepeatedTrue.push(item.active)
      }
    }

    if (arrayRepeatedTrue.length > 0 && !activeStatus) {
      const kmlEdgestate = this.state.region.kmlEdges.findIndex(function (item, index) {
        if (item.active === true) return item.asset.key
      })

      this.state.region.kmlEdges.map((variable, i) => {
        let kmlEdges = [...this.state.region.kmlEdges]
        let kmlEdge = { ...kmlEdges[kmlEdgestate] }

        const name = kmlEdge.asset.name

        this.setState((prevState) => ({
          message: name,
        }))
      })

      this.confirmModal.handleClickOpen()
    } else {
      this.buildChangeCheckbox(activeStatus, itemId)
    }
  }

  buildChangeCheckbox = (activeStatus, itemId) => {
    activeStatus = !activeStatus
    const kmlEdgeIndex = this.state.region.kmlEdges.findIndex(function (item, index) {
      return item.asset.key === itemId
    })

    let kmlEdges = [...this.state.region.kmlEdges]
    let kmlEdge = { ...kmlEdges[kmlEdgeIndex] }

    kmlEdge.active = activeStatus

    kmlEdges[kmlEdgeIndex] = kmlEdge

    const arrayRepeated = []
    for (const item of kmlEdges) {
      if (item.active) {
        arrayRepeated.push(item.active)
      }
    }

    if (arrayRepeated.length > 1) {
      kmlEdges.forEach((el, index) => {
        const isEqual = index === kmlEdgeIndex
        if (!isEqual) {
          el.active = false
        }
      })
    }

    this.setState((prevState) => ({
      region: {
        ...prevState.region,
        kmlEdges: kmlEdges,
      },
    }))
  }

  onSelectChange = (configs) => {
    let value = (configs && configs.length && configs.map((config) => config.value)) || []
    //this.props.onChange('appAccessList', value)

    this.setState((prevState) => ({
      region: {
        ...prevState.region,
        daysClose: value,
      },
    }))
  }

  onChangeAllowedConsumerType = (consumerType) => {
    let value =
      (consumerType &&
        consumerType.length &&
        consumerType.map((consumerType) => consumerType.value)) ||
      []
    this.setState((prevState) => ({
      region: {
        ...prevState.region,
        allowedConsumerTypes: value,
      },
    }))
  }

  getNameTaxRule = () => {
    this.props.dispatch(getTaxRateByCompany()).then((response) => {
      this.setState({ taxRule: response })
    })
  }

  setDeliveryTaxRate = (deliveryTaxRate) => {
    const { region = {} } = this.state
    this.setState({
      region: {
        ...region,
        taxRuleId: deliveryTaxRate.id,
      },
    })
  }

  ondefaultChange = (regionActive, regionid) => {
    regionActive = !regionActive

    this.state.parameterRegion = [regionActive, regionid]
    //add list region
    let regiondef = [...this.state.listregion.values]

    //get  region default
    const arraytrueDefaultRegion = []
    for (const item of regiondef) {
      arraytrueDefaultRegion.push(item.regionDefault)
    }

    const indexRegionTrue = this.state.listregion.values.findIndex(function (item, index) {
      if (item.regionDefault === true) return item.id
    })

    if (indexRegionTrue > -1 && !this.state.region.regionDefault) {
      this.RegionconfirmModal.handleClickOpen()
    } else {
      if (!regionActive) {
        this.RegionconfirmModalFalse.handleClickOpen()
        this.buildChangeRegionCheckbox(!regionActive, regionid)
      } else {
        this.buildChangeRegionCheckbox(regionActive, regionid)
      }
    }
  }

  onConfirmRegionDefault = () => {
    this.buildChangeRegionCheckbox(this.state.parameterRegion[0], this.state.parameterRegion[1])
    this.RegionconfirmModal.handleClose()
    this.RegionconfirmModalFalse.handleClose()
  }

  buildChangeRegionCheckbox = (regionActive, regionid) => {
    const indexRegionNow = this.state.listregion.values.findIndex(function (item, index) {
      return item.id === regionid
    })

    let Regions = [...this.state.listregion.values]
    let Region = { ...Regions[indexRegionNow] }

    Region.regionDefault = regionActive

    Regions[indexRegionNow] = Region

    const arrayRepeatedTrue = []
    for (const item of Regions) {
      if (item.regionDefault) {
        arrayRepeatedTrue.push(item.regionDefault)
      }
    }

    if (arrayRepeatedTrue.length > 1) {
      Regions.forEach((el, index) => {
        const isEqual = index === indexRegionNow
        if (!isEqual) {
          el.regionDefault = false
        }
      })
    }

    this.setState((prevState) => ({
      listregion: {
        ...prevState.listregion,
        values: Regions,
      },
      region: {
        ...prevState.region,
        regionDefault: Region.regionDefault,
      },
    }))
  }

  onCoordinateDefault = () => {
    this.state.region.kmlEdges.map((item, index) => {
      if (item && item.active == true) {
        this.onMaP(item.coordinates, item.coordinates[3], '')
      }
    })
  }

  onMaP = (coordinates, center, kmlColor) => {
    const google = window.google
    const map =
      document.getElementById('map') &&
      new google.maps.Map(document.getElementById('map'), {
        center: center,
        zoom: 9,
      })
    const polygonCoords = coordinates

    const polygon = new google.maps.Polygon({
      paths: polygonCoords,
      strokeColor: kmlColor || this.state.region.kmlColor || '#3e41ea',
      fillColor: kmlColor || this.state.region.kmlColor || '#3e41ea',
      fillOpacity: 0.2,
    })
    polygon.setMap(map)

    google.maps.event.addDomListener(map, 'click', (e) => {
      const resultColor = google.maps.geometry.poly.containsLocation(e.latLng, polygon)
        ? 'blue'
        : 'red'
      const resultPath = google.maps.geometry.poly.containsLocation(e.latLng, polygon) // A triangle.
        ? 'm 0 -1 l 1 2 -2 0 z'
        : google.maps.SymbolPath.CIRCLE
      new google.maps.Marker({
        position: e.latLng,
        map,
        icon: {
          path: resultPath,
          fillColor: resultColor,
          fillOpacity: 0.2,
          strokeColor: 'white',
          strokeWeight: 0.5,
          scale: 9,
        },
      })
    })
  }
  removeFile(f) {
    this.setState({ files: this.state.files.filter((x) => x !== f) })
  }

  // **
  //add modal default region
  onDefaultRegion = () => {
    this.props.dispatch(getRegions()).then((res) => {
      this.travelRegionValues(res.values)
    })
  }

  travelRegionValues = (res) => {
    const regionDefaultState = res.map((item) => {
      const result = true
      if (item.regionDefault) {
        return result
      }
    })
    const finalRegion = regionDefaultState.includes(true)

    if (finalRegion == true) {
      console.log('there is a default region in true')
    } else {
      this.modalRegionDefault.handleClickOpen()
    }
  }

  onHover = (e) => {
    this.setState({ hove: true })
  }

  checkCrossRegions = () => {
    const { region = {} } = this.state
    const { regions = [] } = this.props.companyReducer || {}

    const openAtNumber = this.convertHour(region.openAt)
    const closeAtNumber = this.convertHour(region.closeAt)
    if (closeAtNumber === 0 || (closeAtNumber !== null && closeAtNumber < openAtNumber)) {
      this.setState({
        errors: {
          closeAt: 'Opening Hour/Closing Hour must be on the same day',
        },
      })
      return
    }

    const regionCoordinates =
      (region.kmlEdges &&
        region.kmlEdges.map((kml) => {
          return JSON.stringify(kml.coordinates)
        })) ||
      []
    const activeRegions =
      (regions.values &&
        regions.values.length > 0 &&
        regions.values.filter((item) => item.active && item.id != region.id)) ||
      []

    const repeatKmlRegions =
      activeRegions.filter((regionItem) => {
        const stringCoordinates = regionItem.kmlEdges.map((kml) => {
          return JSON.stringify(kml.coordinates)
        })
        const repeatKml = stringCoordinates.find((el) => el == regionCoordinates)
        return repeatKml ? true : false
      }) || []

    const crossRegions =
      repeatKmlRegions.filter((item) => {
        var openAtNumeric = item.openAtNumeric || 0
        var closeAtNumeric = item.closeAtNumeric || 0
        var openAtValidation = openAtNumeric <= openAtNumber && openAtNumber < closeAtNumeric
        var closeAtValidation = openAtNumeric < closeAtNumber && closeAtNumber <= closeAtNumeric

        if (openAtValidation || closeAtValidation) {
          this.setState({
            errors: {
              openAt: openAtValidation ? 'KML is within the opening hours of another region' : '',
              closeAt: closeAtValidation ? 'KML is within the opening hours of another region' : '',
            },
          })
          return item
        }
        return false
      }) || []

    if (crossRegions.length == 0) {
      !this.state.editMode ? this.onUpdateRegion() : this.onSave()
    }
  }

  onchangeSelectZone = (key) => (event) => {
    const value = event.target.value
    this.setState({ selectZones: value })

    this.setState((prevState) => ({
      region: {
        ...prevState.region,
        zoneType: value,
      },
      errors: {},
    }))

    this.onChange('zoneType', value)
  }

  onChangeZipcodes = (zipCodes) => {
    let updatedZipcodes = []
    zipCodes =
      zipCodes &&
      zipCodes.filter((zipcode) => {
        return zipcode.value && zipcode.value.trim()
      })
    zipCodes.forEach((zipcode) => {
      updatedZipcodes.push(...zipcode.value.split(','))
    })
    this.onChange('zipCodes', updatedZipcodes)

    this.setState((prevState) => ({
      region: {
        ...prevState.region,
        zipCodes: updatedZipcodes,
      },
      errors: {},
    }))
  }

  onVerifyZipCodeRegions = (zipCodes, currentRegion) => {
    const { regions = {} } = this.props.companyReducer
    const dispatchRegions = regions.values || []
    const zipCodeRegions = dispatchRegions.filter(
      (region) => region.id !== currentRegion.id && region.zoneType === 'zipCode',
    )
    let currentZipCodes = []
    let zipCodeNoSpaces
    zipCodeRegions.map((region) => {
      if (region.zipCodes && region.zipCodes.length > 0) {
        currentZipCodes = [...currentZipCodes, ...region.zipCodes]
      }
      return null
    })

    let repetedZipCodes = ''
    let hasRepeatedCode = false

    if (zipCodes && zipCodes.length > 0) {
      for (let zipCode of zipCodes) {
        zipCodeNoSpaces = zipCode.replace(/ /g, '')
        if (currentZipCodes.includes(zipCodeNoSpaces)) {
          repetedZipCodes = zipCode
          hasRepeatedCode = true
          break
        }
      }
    }

    return { hasRepeatedCode, repetedZipCodes }
  }

  checkRegionConsumerFlag = () => {
    monolithIsFeatureFlagEnable(UnleashToggles.REGION_CONSUMER_TYPE).then((res) =>
      this.setState({ regionConsumerTypeFlag: res }),
    )
  }

  render() {
    const {
      loading,
      region = {},
      editMode = false,
      errors = {},
      message,
      arrayZipCode = [],
      showModalDeliveryTaxRate = false,
      regionName = '',
      regionConsumerTypeFlag = false,
      consumerTypes = [],
      consumerTypeDropdownOptions = [],
    } = this.state

    const { active, regionDefault, activeFile } = region || {}

    const user = getSession()
    const { assignedShop = {} } = user
    const { appTarget, nalExciseAfterCityTax = false } = assignedShop

    //messages
    let messageRegion =
      "There's a default region. If you enable this region, it will disable the actual default region and set this one as default region for the all company. Are you sure?"
    let mess = `If you active this KML, you'll disable ${message} . Are you sure?`
    let messageDuplicateKml = "You can't upload KML with the same name"
    let messageDuplicatecoordinates = "You can't upload a KML with duplicated coordinates"
    let messageoverlappingRegion = `This files overlaps with a different region "${regionName}"`
    let mensaggeRegionFalse =
      "This is company default region. If you disable the, auto assign process won't be available. To continue using auto assign process, you must assign a new default region. Are you sure?"
    let { appAccessList = '' } = region || {}
    const selectedConfigs =
      region &&
      region.daysClose &&
      region.daysClose.length &&
      region.daysClose.map((access) =>
        access === 'Dispatch'
          ? { label: 'Days', value: access }
          : { label: access.split(/(?=[A-Z])/).join(' '), value: access },
      )
    const selectedConsumerTypes =
      (region &&
        region.allowedConsumerTypes &&
        region.allowedConsumerTypes.length &&
        region.allowedConsumerTypes.map((consumerType) =>
          consumerTypeDropdownOptions.find((ct) => ct.value === consumerType),
        )) ||
      []
    const messageDefaultRegion =
      "There's no default region for this company. If you don't set one, auto assign proccess won't be available."
    const { flagisNalTaxesOnly = false } = this.props.authReducer || {}

    return (
      <Grid container>
        <Grid className="unversalScroll" item xs={12} sm={5} md={6} lg={5}>
          <div className="table-scroll">
            <Grid container>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                    Region Name*
                  </Grid>
                  <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                    <EditableTextField
                      valueToRender={region.name}
                      editMode={true}
                      value={region.name}
                      onChange={this.onChange('name')}
                      type="text"
                      /*InputLabelProps={{
                                              shrink: true,
                                            }}*/
                      placeholder={'Region Name'}
                    />
                    {errors.name ? (
                      <FormHelperText style={{ color: 'red' }}>{errors.name}</FormHelperText>
                    ) : (
                      ''
                    )}
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                    Active
                  </Grid>
                  <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                    <Switch
                      valueToRender={active ? 'Enabled' : 'Disabled'}
                      value={active}
                      checked={active}
                      editMode={true}
                      onChange={this.onChange('active', true)}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                    Default Region
                  </Grid>
                  <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                    <Switch
                      //valueToRender={region.regionDefault ? "Enabled" : "Disabled"}
                      checked={region.regionDefault}
                      editMode={true}
                      onClick={() => {
                        this.ondefaultChange(region.regionDefault, region.id)
                      }}
                    />
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                    Delivery Fee
                  </Grid>
                  <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                    <EditableInput
                      id="outlined-adornment-amount"
                      type="number"
                      value={region.deliveryFee}
                      editMode={true}
                      onChange={this.onChange('deliveryFee')}
                      startAdornment={<InputAdornment position="start">$</InputAdornment>}
                      error={errors.deliveryFee}
                      helperText={errors.deliveryFee}
                      labelWidth={60}
                    />
                    {errors.deliveryFee ? (
                      <FormHelperText style={{ color: 'red' }}>{errors.deliveryFee}</FormHelperText>
                    ) : (
                      ''
                    )}
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                    Opening Hours
                  </Grid>
                  <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                    <EditableTextField
                      valueToRender={region.openAt}
                      editMode={true}
                      value={region.openAt}
                      onChange={this.onChange('openAt')}
                      type="time"
                    />
                    {errors.openAt ? (
                      <FormHelperText style={{ color: 'red' }}>{errors.openAt}</FormHelperText>
                    ) : (
                      ''
                    )}
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                    Closing Hours
                  </Grid>
                  <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                    <EditableTextField
                      multi={true}
                      valueToRender={region.closeAt}
                      editMode={true}
                      value={region.closeAt}
                      onChange={this.onChange('closeAt')}
                      type="time"
                    />
                    {errors.closeAt ? (
                      <FormHelperText style={{ color: 'red' }}>{errors.closeAt}</FormHelperText>
                    ) : (
                      ''
                    )}
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                    Days Closed
                  </Grid>
                  <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                    <Element>
                      <EditableReactSelect
                        multi={true}
                        valueToRender={appAccessList}
                        editMode={true}
                        value={selectedConfigs}
                        onChange={this.onSelectChange}
                        clearable={true}
                        options={options.length !== selectedConfigs.length ? options : []}
                      ></EditableReactSelect>
                    </Element>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                    Min Cart Subtotal
                  </Grid>
                  <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                    <EditableInput
                      error={errors.minOrderAmount}
                      helperText={errors.minOrderAmount}
                      id="outlined-adornment-amount"
                      type="number"
                      value={region.minOrderAmount}
                      editMode={true}
                      onChange={this.onChange('minOrderAmount')}
                      startAdornment={<InputAdornment position="start">$</InputAdornment>}
                      labelWidth={60}
                    />
                    {errors.minOrderAmount ? (
                      <FormHelperText style={{ color: 'red' }}>
                        {errors.minOrderAmount}
                      </FormHelperText>
                    ) : (
                      ''
                    )}
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                    Free Delivery after
                  </Grid>
                  <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                    <EditableInput
                      error={errors.freeDeliveryAfter}
                      helperText={errors.freeDeliveryAfter}
                      type="number"
                      value={region.freeDeliveryAfter}
                      editMode={true}
                      startAdornment={<InputAdornment position="start">$</InputAdornment>}
                      onChange={this.onChange('freeDeliveryAfter')}
                    />
                    {errors.freeDeliveryAfter ? (
                      <FormHelperText style={{ color: 'red' }}>
                        {errors.freeDeliveryAfter}
                      </FormHelperText>
                    ) : (
                      ''
                    )}
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                    Delivery Tax Rate
                  </Grid>
                  <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                    <EditableSelect
                      error={errors.taxRuleId}
                      helperText={errors.taxRuleId}
                      valueToRender={region.taxRuleId}
                      editMode={true}
                      value={region.taxRuleId}
                      onChange={this.onChange('taxRuleId')}
                    >
                      <MenuItem value="InheritFromShop">Inherit from shop</MenuItem>
                      {this.state.taxRule.map((taxname) => {
                        return <MenuItem value={taxname.id}>{taxname.name}</MenuItem>
                      })}
                    </EditableSelect>
                    {errors.taxRuleId ? (
                      <FormHelperText style={{ color: 'red' }}>{errors.taxRuleId}</FormHelperText>
                    ) : (
                      ''
                    )}
                  </Grid>
                </Grid>
              </ListItem>
              {appTarget && appTarget === 'Retail' && (
                <ListItem>
                  <Grid className="labelField" item xs={12} sm={5} md={5} lg={5} />
                  <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                    <div style={styles}>
                      <Button
                        className="primary-button margin"
                        onClick={() => {
                          this.setState({ showModalDeliveryTaxRate: true })
                        }}
                      >
                        <span style={{ fontSize: 12 }}>Create Delivery Tax Rates</span>
                      </Button>
                    </div>
                  </Grid>
                </ListItem>
              )}
              <ListItem>
                <Grid container>
                  <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                    Zones
                  </Grid>
                  <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                    <EditableSelect
                      valueToRender={region.zoneType}
                      editMode={true}
                      value={region.zoneType}
                      onChange={this.onchangeSelectZone('zoneType')}
                    >
                      {optionZones.map((zones) => {
                        return <MenuItem value={zones.value}>{zones.label}</MenuItem>
                      })}
                    </EditableSelect>
                  </Grid>
                  {region.zoneType == 'kml' ? (
                    <Grid container style={{ marginTop: 30 }}>
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        KML* :{' '}
                      </Grid>
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <div style={styles}>
                          <label className="custom-file-upload">
                            <input
                              type="file"
                              accept=".kml"
                              editMode={editMode}
                              onChange={(e) => {
                                this.handleButtonFile(e)
                                e.target.value = null
                                this.setState({ loading: true, errors: {} })
                              }}
                            />
                            <i className="fa fa-cloud-upload" /> Upload KML
                            {loading ? <LinearProgress color="primary" /> : null}
                            {errors.kml ? (
                              <FormHelperText style={{ color: 'red' }}>{errors.kml}</FormHelperText>
                            ) : (
                              ''
                            )}
                          </label>
                        </div>
                      </Grid>
                      <ListItem>
                        <Grid>
                          <Grid item xs={12} sm={5} md={5} lg={5}>
                            <div container item xs={12} sm={5} md={5} lg={5}>
                              {(this.state.region &&
                                this.state.region.kmlEdges &&
                                this.state.region.kmlEdges.length > 0 &&
                                this.state.region.kmlEdges.map((item, index) => {
                                  if (item) {
                                    return (
                                      <TableRow
                                        onClick={() => {
                                          this.onMaP(item.coordinates, item.coordinates[3])
                                        }}
                                        hover={true}
                                        selected
                                      >
                                        <TableCell item xs={12} sm={3} md={3} lg={3}>
                                          <EditableTextField
                                            style={{ fontSize: 10 }}
                                            valueToRender={item.asset.name}
                                          />
                                        </TableCell>
                                        <TableCell item xs={12} sm={3} md={3} lg={3}>
                                          <div>
                                            <Button
                                              style={styles}
                                              variant="outlined"
                                              onClick={() => {
                                                this.getAssetKml(item.asset.key, item.asset.name)
                                              }}
                                            >
                                              <span style={{ fontSize: 10 }}>Download</span>
                                            </Button>
                                          </div>
                                        </TableCell>
                                        <TableCell>
                                          <div>
                                            <Button
                                              style={styles}
                                              variant="outlined"
                                              onClick={() => {
                                                this.onDeleteKML(index, item.asset.key)
                                              }}
                                            >
                                              <span style={{ fontSize: 10 }}>Delete</span>
                                            </Button>
                                          </div>
                                        </TableCell>
                                        <TableCell align="left">
                                          <Switch
                                            checked={item.active}
                                            //onClick={()=>{this.onKMLActive(item)}}
                                            onClick={() => {
                                              this.handleChange(item.active, item.asset.key)
                                            }}
                                          />
                                        </TableCell>
                                      </TableRow>
                                    )
                                  }
                                })) ||
                                []}
                            </div>
                          </Grid>
                        </Grid>
                      </ListItem>
                    </Grid>
                  ) : null}
                </Grid>
              </ListItem>
              {region.zoneType == 'kml' && (
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                      KML Color
                    </Grid>
                    <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                      <EditableTextField
                        error={errors.kmlColor}
                        helperText={errors.kmlColor}
                        valueToRender={region.kmlColor}
                        editMode={true}
                        value={region.kmlColor}
                        onChange={this.onChange('kmlColor')}
                        type="color"
                        /*InputLabelProps={{
                                                  shrink: true,
                                                }}*/
                        placeholder={'KML Color'}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
              )}
              {region.zoneType == 'zipCode' ? (
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                      Zipcodes*
                    </Grid>
                    <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                      <Element>
                        <EditableReactSelectCreatable
                          multi={true}
                          valueToRender={
                            (region.zipCodes &&
                              region.zipCodes.length &&
                              region.zipCodes.join(', ')) ||
                            ''
                          }
                          editMode={true}
                          value={
                            (region.zipCodes &&
                              region.zipCodes.map((zipcode) => ({
                                label: zipcode,
                                value: zipcode,
                              }))) ||
                            []
                          }
                          // value={(arrayZipCode && arrayZipCode.map((zipcode) => ({label: zipcode, value: zipcode}))) || []}
                          onChange={this.onChangeZipcodes}
                          clearable={true}
                          options={[]}
                        />
                      </Element>
                      {errors.zipCode ? (
                        <FormHelperText style={{ color: 'red' }}>{errors.zipCode}</FormHelperText>
                      ) : (
                        ''
                      )}
                    </Grid>
                  </Grid>
                </ListItem>
              ) : null}
              {regionConsumerTypeFlag && (
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                      Allowed Consumer Types
                    </Grid>
                    <Grid className="editField" item xs={12} sm={6} md={6} lg={5}>
                      <Element>
                        <EditableReactSelect
                          multi={true}
                          valueToRender={appAccessList}
                          editMode={true}
                          value={selectedConsumerTypes}
                          onChange={this.onChangeAllowedConsumerType}
                          clearable={true}
                          options={
                            consumerTypeDropdownOptions.length !== selectedConsumerTypes.length
                              ? consumerTypeDropdownOptions
                              : []
                          }
                        />
                      </Element>
                    </Grid>
                  </Grid>
                </ListItem>
              )}
              <ListItem>
                <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                  <Button
                    variant="contained"
                    className="primary-button margin"
                    onClick={this.checkCrossRegions}
                    disabled={Object.keys(this.state.errors).length > 0 ? true : false}
                  >
                    {!editMode ? 'Update' : 'Save'}
                  </Button>
                </Grid>
                <Grid className="editField" item xs={12} sm={5} md={5} lg={5}>
                  <Button
                    variant="contained"
                    className="danger-button margin"
                    onClick={this.backregions}
                  >
                    Cancel
                  </Button>
                </Grid>
              </ListItem>
            </Grid>
          </div>
        </Grid>
        <Grid className="unversalScroll" item xs={12} sm={6} md={6} lg={6}>
          <Grid container>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              {region && region.kmlEdges.length > 0 && region.kmlEdges ? (
                <div
                  id="map"
                  style={{
                    width: 620,
                    height: 720,
                    display: region.zoneType == 'kml' ? 'block' : 'none',
                  }}
                ></div>
              ) : (
                <div
                  className="editField"
                  item
                  xs={12}
                  sm={5}
                  md={5}
                  lg={5}
                  style={styleNoSelectedMap}
                >
                  <h4>KML not selected</h4>
                </div>
              )}
            </Grid>
          </Grid>
        </Grid>

        <ModalDialog
          title={mess}
          ref={(c) => (this.confirmModal = c)}
          onConfirm={this.onConfirm}
          //onClose={this.onClose}
          onClose={this.handleClose}
          confirmText="Yes"
          cancelText="No"
        ></ModalDialog>
        <ModalDialog
          title={messageDuplicateKml}
          ref={(c) => (this.modalDuplicateKml = c)}
          cancelText="ok"
          confirmText={false}
        ></ModalDialog>
        <ModalDialog
          title={messageDuplicatecoordinates}
          ref={(c) => (this.modalDuplicatecoordinates = c)}
          cancelText="ok"
          confirmText={false}
        ></ModalDialog>
        <ModalDialog
          title={messageoverlappingRegion}
          ref={(c) => (this.modalOverlappingRegion = c)}
          cancelText="ok"
          hideSave={true}
        ></ModalDialog>
        <ModalDialog
          title={messageRegion}
          ref={(c) => (this.RegionconfirmModal = c)}
          onConfirm={this.onConfirmRegionDefault}
          //onClose={this.onClose}
          onClose={this.handleClose}
          confirmText="Yes"
          cancelText="No"
        ></ModalDialog>
        <ModalDialog
          title={mensaggeRegionFalse}
          ref={(c) => (this.RegionconfirmModalFalse = c)}
          onConfirm={this.onConfirmRegionDefault}
          //onClose={this.onClose}
          onClose={this.handleClose}
          confirmText="Yes"
          cancelText="No"
        ></ModalDialog>
        <ModalDialog
          title={messageDefaultRegion}
          ref={(c) => (this.modalRegionDefault = c)}
          cancelText="ok"
          confirmText={false}
        ></ModalDialog>
        <ModalDeliveryTaxRate
          dispatch={this.props.dispatch}
          open={showModalDeliveryTaxRate}
          onClose={() => {
            this.setState({ showModalDeliveryTaxRate: false })
          }}
          getNameTaxRule={this.getNameTaxRule}
          setDeliveryTaxRate={this.setDeliveryTaxRate}
          isNalTaxesOnly={flagisNalTaxesOnly}
          isNalExciseAfterCityTax={nalExciseAfterCityTax}
          consumerTypes={consumerTypes}
        />
      </Grid>
    )
  }
}

export default connect(({ dispatch, shopReducer, authReducer, companyReducer }) => ({
  dispatch,
  shopReducer,
  authReducer,
  companyReducer,
}))(ContainerWithTitle(RegionsEdit, 'Region Add/Edit'))



// WEBPACK FOOTER //
// ./src/components/Regions/RegionsEdit.js